export const productDataKeys = {
	index: ["product-data"],
	locales: () => [...productDataKeys.index, "locales"],
};
